import { render, staticRenderFns } from "./salesListTable.vue?vue&type=template&id=3a19770d&"
import script from "./salesListTable.vue?vue&type=script&lang=js&"
export * from "./salesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports